import { useTranslation } from 'react-i18next';
import { Anchor, Box, Flex, Group, Image, Stack, Text, Title } from '@mantine/core';
import { IconMail, IconPhone } from '@tabler/icons-react';
import Benefits from '@/components/landing/Benefits';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '@/lib/contacts';

const HEADER_HEIGHT = 64;

// Layout как в оригинале /about: во всю высоту экрана, слева ~40% (макс 834px) фото на оливковом
// фоне, справа — светло-серая панель с инфо (название, слоган, контакты, адрес) и преимуществами внутри.
export default function About() {
  const { t } = useTranslation();

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      align="stretch"
      mih={{ md: `calc(100dvh - ${HEADER_HEIGHT}px)` }}
    >
      <Box
        w={{ base: '100%', md: '40%' }}
        maw={{ md: 834 }}
        style={{ backgroundColor: '#90915d', overflow: 'hidden' }}
      >
        <Image
          src="/images/about.webp"
          alt=""
          fit="cover"
          w={{ base: '100%', md: 834 }}
          h={{ base: 240, sm: 360, md: '100%' }}
        />
      </Box>

      <Box flex="1" bg="gray.0" px={{ base: 'md', md: 56 }} py={{ base: 'xl', md: 48 }}>
        <Stack justify="center" h="100%" gap={48}>
          <Stack gap="lg" maw={690}>
            <Title order={1} fz={{ base: 26, sm: 36 }}>
              {t('about.companyName')}
            </Title>
            <Text fz={{ base: 'md', sm: 'lg' }} c="gray.7">
              {t('about.tagline')}
            </Text>
            <Stack gap="xs">
              <Group gap="sm">
                <IconPhone size={20} color="var(--mantine-color-brand-6)" />
                <Anchor href={CONTACT_PHONE_HREF} c="var(--mantine-color-text)">
                  {CONTACT_PHONE}
                </Anchor>
              </Group>
              <Group gap="sm">
                <IconMail size={20} color="var(--mantine-color-brand-6)" />
                <Anchor href={`mailto:${CONTACT_EMAIL}`} c="var(--mantine-color-text)">
                  {CONTACT_EMAIL}
                </Anchor>
              </Group>
            </Stack>
            <Text c="gray.7">{t('about.address')}</Text>
          </Stack>

          <Benefits onLight />
        </Stack>
      </Box>
    </Flex>
  );
}
